import React from 'react';
import { Dialog, DialogContent, Typography, TextField, Box, Button } from '@mui/material';

interface AddNewModelModalProps {
    open: boolean;
    title: string;
    value: string;
    onChange: (val: string) => void;
    onClose: () => void;
    onSubmit: () => void;
}

const AddNewModelModal: React.FC<AddNewModelModalProps> = ({ 
    open, 
    title, 
    value, 
    onChange, 
    onClose, 
    onSubmit 
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{ sx: { borderRadius: '8px', width: '300px', p: 1 } }}
        >
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{title}</Typography>
                <TextField 
                    label="Model Name" 
                    size="small" 
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    autoFocus
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
                    <Button onClick={onClose} color="inherit">
                        Cancel
                    </Button>
                    <Button 
                        variant="contained" 
                        className="custom-button" 
                        onClick={() => {
                            onSubmit();
                            onClose(); 
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AddNewModelModal;